'use client';

import { c as _c } from "react/compiler-runtime";
import AuthWidgetContext from '@shared/utils/context/AuthWidgetContext';
import dynamic from 'next/dynamic';
import { useContext } from 'react';
import { createPortal } from 'react-dom';
import Modal, { ModalContent } from '../components/HOC/Modal';
import usePresence from '../hooks/usePresence';

// Every widget below renders behind a context boolean, but static imports put
// the whole auth + onboarding surface into the root Provider chunk, so every
// anonymous marketing visitor downloaded it before clicking anything. These are
// modals, never crawlable content, so `ssr: false` costs no SEO.
const AuthContinue = dynamic(() => import('../components/auth/AuthContinue'), {
  ssr: false
});
const LoginComponent = dynamic(() => import('../components/auth/Login'), {
  ssr: false
});
const Logout = dynamic(() => import('../components/auth/Logout'), {
  ssr: false
});
const Signup = dynamic(() => import('../components/auth/Signup').then(m => m.Signup), {
  ssr: false
});
const ActivationFunnel = dynamic(() => import('../components/onboarding/activationFunnel/ActivationFunnel'), {
  ssr: false
});
const PostSignupFlow = dynamic(() => import('../components/onboarding/activationFunnel/PostSignupFlow'), {
  ssr: false
});
const AuthWidgets = () => {
  const $ = _c(27);
  const {
    authContinueModalOpen,
    setAuthContinueModalOpen,
    logoutModalOpen,
    setLogoutModalOpen,
    loginModalOpen,
    setLoginModalOpen,
    signupModalOpen,
    setSignupModalOpen,
    funnelOpen,
    setFunnelOpen,
    postSignupStep,
    isAddAccountMode
  } = useContext(AuthWidgetContext);
  const funnelPresence = usePresence(funnelOpen, 350);
  let t0;
  if ($[0] !== setLoginModalOpen) {
    t0 = () => {
      setLoginModalOpen(false);
    };
    $[0] = setLoginModalOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const closeLoginModal = t0;
  let t1;
  if ($[2] !== authContinueModalOpen || $[3] !== setAuthContinueModalOpen) {
    t1 = authContinueModalOpen && <AuthContinue closeHandler={() => setAuthContinueModalOpen(false)} />;
    $[2] = authContinueModalOpen;
    $[3] = setAuthContinueModalOpen;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== logoutModalOpen || $[6] !== setLogoutModalOpen) {
    t2 = logoutModalOpen && <Logout closeHandler={() => setLogoutModalOpen(false)} />;
    $[5] = logoutModalOpen;
    $[6] = setLogoutModalOpen;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== closeLoginModal || $[9] !== isAddAccountMode || $[10] !== loginModalOpen) {
    t3 = loginModalOpen && <Modal maxWidth={550} closeHandler={closeLoginModal}><ModalContent><LoginComponent closeHandler={closeLoginModal} isAddAccountMode={isAddAccountMode} /></ModalContent></Modal>;
    $[8] = closeLoginModal;
    $[9] = isAddAccountMode;
    $[10] = loginModalOpen;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== setSignupModalOpen || $[13] !== signupModalOpen) {
    t4 = signupModalOpen && <Modal maxWidth={550} closeHandler={() => setSignupModalOpen(false)}><ModalContent><Signup closeHandler={() => setSignupModalOpen(false)} /></ModalContent></Modal>;
    $[12] = setSignupModalOpen;
    $[13] = signupModalOpen;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== postSignupStep) {
    t5 = postSignupStep && <PostSignupFlow />;
    $[15] = postSignupStep;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== funnelPresence || $[18] !== setFunnelOpen) {
    t6 = typeof document !== "undefined" && createPortal(funnelPresence.rendered ? <div data-onboarding-overlay={true} className={`fixed inset-0 z-[150] bg-background-primary [--enter-duration:350ms] [--enter-ease:cubic-bezier(0.4,0,0.2,1)] [--exit-duration:350ms] [--exit-ease:cubic-bezier(0.4,0,0.2,1)] ${funnelPresence.exiting ? "anim-exit" : "anim-enter"}`}><ActivationFunnel onClose={() => setFunnelOpen(false)} /></div> : null, document.body);
    $[17] = funnelPresence;
    $[18] = setFunnelOpen;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
    t7 = <>{t1}{t2}{t3}{t4}{t5}{t6}</>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};
export default AuthWidgets;